<template>
    <VueFinalModal
        class="confirm-modal flex justify-center items-center px-4"
        content-class="confirm-modal-content"
        overlay-transition="vfm-fade"
        content-transition="vfm-fade"
    >
        <div class="bg-white rounded-lg overflow-hidden shadow-xl max-w-2xl w-full">
            <div class="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                <h3 class="text-lg font-medium text-gray-900">Welcome Message</h3>
                <button
                    @click="$emit('close')"
                    class="text-gray-600 hover:text-gray-700"
                >
                    <font-awesome :icon="['fas', 'x']" class="w-3.5 h-3.5" />
                </button>
            </div>
            <div class="px-6 py-6 max-h-96 overflow-y-auto">
                <div v-html="welcomeMessage" class="
                    prose prose-sm max-w-none text-gray-700
                    prose-ul:list-disc prose-ol:list-decimal
                    prose-li:my-1 prose-p:my-2
                    prose-headings:font-bold prose-h1:text-[1.75rem] prose-h2:text-[1.5rem] prose-h3:text-[1.25rem]
                    prose-a:text-primary prose-a:underline hover:prose-a:no-underline
                "></div>
            </div>
        </div>
    </VueFinalModal>
</template>

<script setup>
import { VueFinalModal } from 'vue-final-modal';

const props = defineProps({
    welcomeMessage: {
        type: String,
        required: true
    }
});

defineEmits(['close']);
</script>
